export const EMAIL_SOURCES = {
  LISTS: 'LISTS',
  EVENTS: 'EVENTS',
  TEAMS: 'TEAMS',
}
